import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import "./styles/Congrats.css";
import Icons from "../components/icons";
import congrats from "../assets/congrats.png";
import congratsGif from "../assets/c.gif";

const Congrats = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [secondsLeft, setSecondsLeft] = useState(60); // 👈 Track the 60-second countdown

  // Read from onboardingSlice — has full data including employeeId
  const onboardedUser = useSelector((state) => state.onboarding?.onboardedUser);
  const userData = onboardedUser || location.state?.user || {};

  // viewer has no employeeId
  const isViewer = !userData.employeeId;

  // ─────────────────────────────────────────
  // EFFECT: Handle 60s Countdown and Redirect
  // ─────────────────────────────────────────
  useEffect(() => {
    if (secondsLeft === 0) {
      navigate("/");
      return;
    }
    const timer = setTimeout(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [secondsLeft, navigate]);

  const joiningDate = userData.dateOfJoining
    ? new Date(userData.dateOfJoining).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      })
    : "01 April, 2026";

  return (
    <div className="congrats-container">
      <img src={congratsGif} alt="" className="congrats-page-gif" />

      <div className="top-logo">
        <Icons.Logo />
        <span>QwickHub</span>
      </div>

      <div className="congrats-content">
        <div className="left-section">
          <img src={congrats} alt="Onboarding" className="onboarding-image" />
        </div>

        <div className="right-section">
          <h1>Congrats, You've Onboarded</h1>

          {isViewer ? (
            // viewer — no employee ID
            <>
              <p>
                Welcome, <strong>{userData.name || "there"}</strong>!
              </p>
              <p>Your Date Of Joining Is {joiningDate.toUpperCase()}</p>
            </>
          ) : (
            // member / admin / manager — show employee ID
            <>
              <p>
                Your Employee ID is <strong>{userData.employeeId}</strong>
              </p>
              <p>Your Date Of Joining Is {joiningDate.toUpperCase()}</p>
            </>
          )}

          <p className="details-link">
            For more details, explore{" "}
            <span onClick={() => navigate("/")}>QwickHub</span>
          </p>

          {/* 👈 Redirect Message matching layout, size, and styling colors exactly */}
          <p
            className="details-link"
            style={{ marginTop: "1rem", opacity: 0.85, cursor: "default" }}
          >
            You will be redirected to the Login Page in{" "}
            <strong style={{ color: "#2563eb" }}>{secondsLeft}s</strong>
          </p>
        </div>
      </div>

      <div className="footer-text">© QwickBit Technologies Pvt Ltd, 2026</div>
    </div>
  );
};

export default Congrats;
